export default __webpack_public_path__ + "static/media/events_form.530cb119.xlsx";